import { Image, type HeaderCategory } from '../../../modules/design-system';
import { useScrollRow } from '../shared/useScrollRow';

type Props = {
  categories: HeaderCategory[];
  activeId?: string;
  onSelect?: (id: string) => void;
};

/**
 * The phone's category row (repackz-handoff §8.2): glass circles 40 across
 * with the category art, the name under each — the picked one rimmed in
 * white and its name bold. Scrolls sideways when the row is wider than the
 * screen, fading at the edges it can still scroll past. A category without
 * art shows its initial.
 */
export function CategoryCircles({ categories, activeId, onSelect }: Props) {
  // The fade goes on each circle and name: the circle's glass is a part.
  const rowRef = useScrollRow<HTMLDivElement>(categories.length, 'parts');
  return (
    <div ref={rowRef} className="scrollbar-hide flex gap-[15px] overflow-x-auto px-4">
      {categories.map((category) => {
        const isActive = category.id === activeId;
        return (
          <button
            key={category.id}
            type="button"
            aria-pressed={isActive}
            onClick={() => onSelect?.(category.id)}
            className="flex w-14 shrink-0 cursor-pointer flex-col items-center gap-1"
          >
            <span
              className={
                'relative flex size-10 items-center justify-center overflow-hidden rounded-full text-[15px] font-semibold text-white ' +
                'backdrop-blur-[17px] [background:var(--glass-round-fill)] ' +
                (isActive ? 'border border-solid [border-color:var(--co-CategoryPill-activeFill,#ffffff)]' : '')
              }
            >
              {category.iconSrc ? (
                <Image
                  src={category.iconSrc}
                  alt=""
                  className="absolute inset-0"
                  imgClassName="absolute inset-0 h-full w-full object-cover"
                />
              ) : (
                category.label.charAt(0)
              )}
            </span>
            <span
              className={
                'max-w-[71px] truncate text-[12px] leading-4 ' +
                (isActive ? 'font-semibold text-white' : 'font-normal [color:var(--glass-text-muted)]')
              }
            >
              {category.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
